import { render, staticRenderFns } from "./CpmTransactionDetail.vue?vue&type=template&id=31f0d3b7"
import script from "./CpmTransactionDetail.vue?vue&type=script&lang=js"
export * from "./CpmTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports